import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'app/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'app/components/ui/table';
import { useDashboardSlice } from '../../slice';
import { useEffect } from 'react';
import { formatDistanceToNow } from 'date-fns';
import { Link } from 'react-router-dom';
import { ORDER_STATUS_DETAILS, PAYMENT_STATUS_DETAILS } from 'utils/constants';
import { ArrowRight, ShoppingCart } from 'lucide-react';
import { formatISTDateToNow } from 'utils/formatRelativeTime';
import { convertDateFormat } from 'utils/format-date';
export function RecentOrdersTable() {
  const { useGetRecentOrdersQuery } = useDashboardSlice();
  const [getRecentOrders, { data: recentOrders }] = useGetRecentOrdersQuery({});

  useEffect(() => {
    getRecentOrders();
  }, []);

  return (
    <Card className="border-none bg-white dark:bg-transparent rounded-2xl overflow-hidden">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 py-3 bg-[#059669] text-white">
        <CardTitle className="text-md font-medium flex items-center gap-2">
          <ShoppingCart className="w-4 h-4 text-white" />
          Recent Orders
        </CardTitle>
        <Link
          to="/orders"
          className="text-xs  hover:underline uppercase flex items-center gap-1"
        >
          View All <ArrowRight className="w-4 h-4" />
        </Link>
      </CardHeader>
      <CardContent className="mt-4 overflow-x-auto max-h-[530px] overflow-y-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-gray-500 text-xs uppercase whitespace-nowrap">
                Order ID
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase">
                Username
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase">
                Total
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase whitespace-nowrap">
                Order Status
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase whitespace-nowrap">
                Payment Status
              </TableHead>
              <TableHead className="text-gray-500 text-xs uppercase whitespace-nowrap">
                Created At
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {recentOrders?.data?.length ? (
              recentOrders.data.map(order => {
                const orderStatus = ORDER_STATUS_DETAILS[order.order_status];
                const paymentStatus =
                  PAYMENT_STATUS_DETAILS[order.payment_status];

                return (
                  <TableRow key={order.order_id} className="hover:bg-gray-50">
                    <TableCell>{order.order_id}</TableCell>
                    <TableCell>{order?.username}</TableCell>
                    <TableCell className="whitespace-nowrap">
                      {order?.currency} {order?.total_amount}
                    </TableCell>
                    <TableCell>
                      {orderStatus ? (
                        <span
                          className={`inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-medium shadow-sm ${orderStatus.color}`}
                        >
                          {orderStatus.label}
                        </span>
                      ) : (
                        <span className="text-xs text-gray-500">Unknown</span>
                      )}
                    </TableCell>
                    <TableCell>
                      {paymentStatus ? (
                        <span
                          className={`inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-medium shadow-sm ${paymentStatus.color}`}
                        >
                          {paymentStatus.label}
                        </span>
                      ) : (
                        <span className="text-xs text-gray-500">Unknown</span>
                      )}
                    </TableCell>
                    <TableCell className="whitespace-nowrap">
                      {convertDateFormat(order.created_at)}
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell
                  colSpan={6}
                  className="text-center text-gray-400 py-8"
                >
                  No recent orders found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
